// import logo from './logo.svg';
import './components/assets/css/App.css';
import Portfolio from './components/PortfolioContainer';

function App() {
  return (
    <Portfolio />
  );
}

export default App;
